const animation_duration = 350;
const animation_position_open = '0%';
const animation_position_close = '-110%';

$(document).ready(function() {

  //================================================
  //Open Menu
  //================================================
  $(document).on('click', '.mobileMenu-toggle, .mobileMenu-toggle__Icon', function(event) {
    event.preventDefault();
    animateMenu('.custom-mobile-navigation__container-lvl1', animation_position_open, animation_duration);
    $('.custom-mobile-navigation__overlay').removeClass('custom-mobile-navigation__overlay--clear');
  });

  //================================================
  //Close Menu
  //================================================
  $(document).on('click', '.nav-header__close-button', function(event) {
    let closest_menu = $(event.target).closest('.custom-mobile-navigation__container-lvl1, .custom-mobile-navigation__container-lvl2, .custom-mobile-navigation__container-lvl3');
    animateMenu(closest_menu, animation_position_close, animation_duration);
  });

  $(document).on('click', '.custom-mobile-navigation__overlay', function(event) {
    animateMenu('.custom-mobile-navigation__container-lvl1, .custom-mobile-navigation__container-lvl2, .custom-mobile-navigation__container-lvl3', animation_position_close, animation_duration);
  });

  //================================================
  //Close overlay
  //================================================
  $(document).on('click', '#nav-header__close-button, .custom-mobile-navigation__overlay', function(event) {
    $('.custom-mobile-navigation__overlay').addClass('custom-mobile-navigation__overlay--clear');
  });

  //================================================
  //Click to level 2
  //================================================
  $(document).on('click', '.custom-mobile-navigation__link-lvl1', function(event) {
    
    $('.custom-mobile-navigation__links-lvl2').empty();
    
    let clicked_li_container = $(event.target).closest('.custom-mobile-navigation__link');
    let clicked_link_list = $('.custom-mobile-navigation__lvl1[data-collection-name="' + $(clicked_li_container).data('collection-name') + '"]').find('.custom-mobile-navigation__lvl2');

    editTitle('.custom-mobile-navigation__title-lvl2', clicked_li_container);
    $('.custom-mobile-navigation__links-lvl2').append('<li class="custom-mobile-navigation__link custom-mobile-navigation__link-lvl2" data-collection-name="' + $(clicked_li_container).data('collection-name') + '" data-collection-url="' + $(clicked_li_container).data('collection-url') + '"><a href="' + $(clicked_li_container).data('collection-url') + '"><span>Go To ' + $(clicked_li_container).data('collection-name') + '</span></a></li>');

    if(clicked_link_list.length > 0) {
      event.preventDefault();

      clicked_link_list.each(function() {
        $('.custom-mobile-navigation__links-lvl2').append('<li class="custom-mobile-navigation__link custom-mobile-navigation__link-lvl2 custom-mobile-navigation__link--font-weight-normal" data-collection-name="' + $(this).data('collection-name') + '" data-collection-url="' + $(clicked_li_container).data('collection-url') + '"><a href="' + $(this).data('collection-url') + '"><span>' + $(this).data('collection-name') + '</span></a></li>');
      });

      animateMenu('.custom-mobile-navigation__container-lvl2', animation_position_open, animation_duration);
    } else {
      window.location.href = $(this).find('a').attr('href');
    }
    
  });

  //================================================
  //Click to level 3
  //================================================
  $(document).on('click', '.custom-mobile-navigation__link-lvl2', function(event) {
    
    $('.custom-mobile-navigation__links-lvl3').empty();
    
    let clicked_li_container = $(event.target).closest('.custom-mobile-navigation__link');
    let clicked_link_list = $('.custom-mobile-navigation__lvl2[data-collection-name="' + $(clicked_li_container).data('collection-name') + '"]').find('.custom-mobile-navigation__lvl3');

    editTitle('.custom-mobile-navigation__title-lvl3', clicked_li_container);
    $('.custom-mobile-navigation__links-lvl3').append('<li class="custom-mobile-navigation__link-lvl3" data-collection-name="' + $(clicked_li_container).data('collection-name') + '" data-collection-url="' + $(clicked_li_container).data('collection-url') + '"><a href="' + $(clicked_li_container).data('collection-url') + '"><span>Go To ' + $(clicked_li_container).data('collection-name') + '</span></a></li>');

    if(clicked_link_list.length > 0 && $(clicked_li_container).hasClass('custom-mobile-navigation__link--font-weight-normal')) {
      event.preventDefault();

      clicked_link_list.each(function() {
        $('.custom-mobile-navigation__links-lvl3').append('<li class="custom-mobile-navigation__link-lvl3 custom-mobile-navigation__link--font-weight-normal"><a href="' + $(this).data('collection-url') + '"><span>' + $(this).data('collection-name') + '</span></a></li>');
      });

      animateMenu('.custom-mobile-navigation__container-lvl3', animation_position_open, animation_duration);
    } else {
      window.location.href = $(this).find('a').attr('href');
    }
  });

  //================================================
  //Click level 3 link
  //================================================
  $(document).on('click', '.custom-mobile-navigation__link-lvl3', function(event) {
    window.location.href = $(this).find('a').attr('href');
  });
  
});

//================================================
//Helper functions
//================================================
function animateMenu(menu, position, duration) {
  $(menu).animate({
    left: position
  }, duration);
}

function editTitle(title_element, clicked_element) {
  $(title_element).html($(clicked_element).data('collection-name'));
}